import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators'
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  baseURL: string;
  searchData = {
    selectedApplication: "",
    startDate: new Date(),
    endDate: new Date(),
    selectedCategories: [],
    selectedCategoryNames: []
  };

  selectedIndex = 0;
  selectedItemIndex: number;
  categoryItems = [];
  selectedItem: any;
  applicationUrl : string;
  applicationCategoryURL = "";
  //applicationCategoryURL = "https://api.myjson.com/bins/yudzk";
  //applicationUrl = 'https://api.myjson.com/bins/dawh0';

  constructor(private http: HttpClient) { }

  /*
  *function to fetch the all the registered applications
  */
  getApplication() {
    this.applicationUrl = this.baseURL + 'applications';
    return this
      .http
      .get(`${this.applicationUrl}`)
      .pipe(catchError(this.handleError));
  }

  /*
  *function to fetch the Categories
  * @param  application - Application name is passed (ex: MRS)
  */
  getApplicationCategories(application: string) {
    this.applicationCategoryURL = this.baseURL + 'applications/' + application + '/categories';
    return this
      .http
      .get(`${this.applicationCategoryURL}`)
      .pipe(catchError(this.handleError));
  }

  /*
  *function to catch the error
  */
  handleError(error: HttpErrorResponse){
    return throwError(error);
  }
}
